import Meta from 'components/meta/meta'
import Features from 'components/features/features'

export default function Page() {
    return (
        <>
            <Meta
                title="Išskirtinumai"
                description="Unikalus pirkėjas vertas unikalių pasiūlymų - atraskite dar nematytas lietuviškas prekes sau ir savo artimiesiems."
            />
            <Features tag="h1" all />
        </>
    )
}
